import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import { typeLabels } from "@/mocks/movies";
import { formatPlays, typeBadgeClass } from "@/utils/format";

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block cursor-pointer overflow-hidden rounded-lg border border-background-200/70 bg-background-100 transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 影视封面`}
          title={`${movie.title} - 97视频`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-80"></div>
        <span
          className={`absolute left-2 top-2 rounded-md px-2 py-0.5 text-xs font-medium ${typeBadgeClass(movie.type)}`}
        >
          {typeLabels[movie.type]}
        </span>
        <span className="absolute right-2 top-2 rounded-md bg-black/60 px-2 py-0.5 text-xs font-semibold text-accent-400">
          {movie.rating.toFixed(1)}
        </span>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-accent-500 text-background-50">
            <i className="ri-play-fill text-2xl" aria-hidden="true"></i>
          </span>
        </div>
        <div className="absolute bottom-2 left-2 right-2 flex items-center gap-1 text-xs text-white/90">
          <i className="ri-fire-line text-accent-400" aria-hidden="true"></i>
          <span>{formatPlays(movie.plays)}次播放</span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="truncate font-heading text-sm font-semibold text-foreground-950">
          {movie.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">
          {movie.year} · {movie.region} · {movie.genres.slice(0, 2).join(" / ")}
        </p>
      </div>
    </Link>
  );
}